export default "__VITE_ASSET__28a9e63a__"